import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full max-w-7xl mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-xs md:text-sm text-foreground-500">
        {items.map((item, index) => (
          <li key={index} className="flex items-center whitespace-nowrap">
            {index > 0 && (
              <span className="mx-1.5 text-foreground-300" aria-hidden="true">/</span>
            )}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors duration-200">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}